import { Dialog } from '@mui/material';
import { FunctionComponent, useState } from 'react';

import { WorkSelectors } from '../../../../reducers/work';
import AttachmentUpload from '../AttachmentUpload';
import { FooterButton } from '../FooterButtons/styled';
import { 
    ApproveDialogButtonContainer,
    ApproveDialogContent, 
    ApproveDialogDescription,
    AttachmentUploadWrapper, dialogPaperProps, 
    DialogTitle } from './styled';

interface ApproveDialogProps {
    open: boolean;
    attachmentIds: number[];
    setAttachmentIds: React.Dispatch<React.SetStateAction<number[]>>;
    onSubmit: () => void;
    instructions?: string;
}

const ApproveDialog: FunctionComponent<ApproveDialogProps> = ({
    open,
    attachmentIds,
    setAttachmentIds,
    onSubmit,
    instructions
}) => {

    const { work } = WorkSelectors();
    
    const [ isUploading, setIsUploading ] = useState(false);
    
    const handleClose = () => {
        // 
        // dialog should not close on backdrop click
    };
    
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown // Prevent closing on ESC key
            aria-labelledby="approve-dialog-title"
            aria-describedby="approve-dialog-description"
            PaperProps={dialogPaperProps}
            maxWidth={false}
            fullWidth
        >
            <DialogTitle id="approve-dialog-title">Approve</DialogTitle>
            <ApproveDialogContent>
                <ApproveDialogDescription>
                    Please upload proof of work to complete the approval.
                </ApproveDialogDescription>
                <AttachmentUploadWrapper>
                    <AttachmentUpload
                        attachmentIds={attachmentIds}
                        setAttachmentIds={setAttachmentIds}
                        title="Proof of work"
                        instructions={instructions || 'Please upload a video (or, if that\'s not possible, at least an image) that demonstrates that the code matches the task requirements. If the work is intended to run on multiple devices, make sure to show how it works on each of them.'}
                        resetKey={work?.id}
                        onUploadingChange={setIsUploading}
                    />
                </AttachmentUploadWrapper>
                <ApproveDialogButtonContainer>
                    <FooterButton 
                        onClick={onSubmit}
                        disabled={attachmentIds.length === 0 || isUploading}
                    >
                        Submit
                    </FooterButton>
                </ApproveDialogButtonContainer>
            </ApproveDialogContent>
        </Dialog>
    );
};

export default ApproveDialog;

